import { protectWithAccountPermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { BillingPage } from 'features/billing'
import { subscriptionsQueryOptions } from 'hooks/api/subscriptions'
import { useToast } from 'hooks/toast'
import { canViewBillingPermission } from 'hooks/usePermission'
import { useEffect } from 'react'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/billing')({
  component: WorkspaceBillingRouteComponent,
  validateSearch: (search: Record<string, unknown>): { migrated?: number } => ({
    migrated: search.migrated === undefined ? undefined : Number(search.migrated),
  }),
  loader: ({ context: { queryClient, buildRequest } }) => {
    queryClient.prefetchQuery(subscriptionsQueryOptions(buildRequest, ['usageQuota']))
  },
  head: () => ({
    meta: [
      {
        title: withCompanyName('Billing'),
      },
    ],
  }),
  // Billing permissions are account-scoped even though the page is served under $subscriptionId.
  beforeLoad: protectWithAccountPermissions(canViewBillingPermission),
})

function WorkspaceBillingRouteComponent() {
  const { migrated } = Route.useSearch()
  const navigate = Route.useNavigate()
  const { showToast } = useToast()

  useEffect(() => {
    if (migrated) {
      showToast({ severity: 'success', message: 'Billing migration complete.' })
      navigate({ to: '.', search: {}, replace: true })
    }
  }, [migrated, showToast, navigate])

  return <BillingPage />
}
